import { asyncDefaults, makeAsyncReducer, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';

const fetchActivities = makeAsyncReducer(types.FETCH_ACTIVITIES);

export default mergeReducers(asyncDefaults([]), types.PREFIX, fetchActivities);

export const getActivities = (state) => state.portal.activities.data;
